import { render, staticRenderFns } from "./TheWorkflowAdmin.vue?vue&type=template&id=5cb16742&"
import script from "./TheWorkflowAdmin.vue?vue&type=script&lang=js&"
export * from "./TheWorkflowAdmin.vue?vue&type=script&lang=js&"
import style0 from "./TheWorkflowAdmin.vue?vue&type=style&index=0&id=5cb16742&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports